function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _Object$assign;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { InternalButtonLink } from "../../internal";
import { allowedBadgeSymbols } from "../../utils/badge";
import { allowedTooltipSymbols } from "../../utils/tooltip";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * This is a link that looks like a button.
 *
 * ## Accessibility ♿
 * - This should be used instead of a button whenever any sort of navigation
 *   occurs.  This is important so that the link shows up in the list of links
 *   for screen readers.  It's also important for link functionality, such as
 *   "right click + open in new tab", "CMD+click", "right click + copy link",
 *   etc.
 * - If there is no navigation, do not use this component - use a regular Button
 *   instead.  For more information on when to use button vs link and link
 *   accessibility in general, see [this documentation](https://applyboard.atlassian.net/wiki/spaces/UE/pages/2728788050/Link+Accessibility)
 * - Accessibility features:
 *   - Visible focus ring for keyboard users
 *   - Space activates the link
 *   - Awkward name for `mode="override_user_choice_and_open_in_new_tab"` to encourage consumers to think whether it's a good idea to open a link in a new tab
 *   - When link opens in new tab by default, adds an accompanying external link icon and "(Opens in new tab)" as invisible text for screen readers
 */
export var ButtonLink = /*#__PURE__*/React.forwardRef(function ButtonLink(_ref, ref) {
  var ariaDescribedby = _ref['aria-describedby'],
    ariaLabel = _ref['aria-label'],
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    download = _ref.download,
    _ref$emphasis = _ref.emphasis,
    emphasis = _ref$emphasis === void 0 ? 'contained' : _ref$emphasis,
    gradient = _ref.gradient,
    hideAbove = _ref.hideAbove,
    hideBelow = _ref.hideBelow,
    href = _ref.href,
    id = _ref.id,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? 'secondary' : _ref$intent,
    leadIcon = _ref.leadIcon,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    m = _ref.m,
    mb = _ref.mb,
    ml = _ref.ml,
    mode = _ref.mode,
    mr = _ref.mr,
    mt = _ref.mt,
    mx = _ref.mx,
    my = _ref.my,
    onAfterHistoryPush = _ref.onAfterHistoryPush,
    onBlur = _ref.onBlur,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onPointerDown = _ref.onPointerDown,
    onPointerLeave = _ref.onPointerLeave,
    onPointerMove = _ref.onPointerMove,
    rel = _ref.rel,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    trailIcon = _ref.trailIcon,
    variant = _ref.variant,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'hug' : _ref$width;
  return _jsx(InternalButtonLink, {
    "aria-describedby": ariaDescribedby,
    "aria-label": ariaLabel,
    disabled: disabled,
    download: download !== null && download !== void 0 ? download : undefined,
    emphasis: emphasis,
    gradient: gradient,
    hideAbove: hideAbove,
    hideBelow: hideBelow,
    href: href,
    id: id,
    intent: gradient ? undefined : intent,
    leadIcon: leadIcon,
    loading: loading,
    m: m,
    mb: mb,
    ml: ml,
    mode: mode,
    mr: mr,
    mt: mt,
    mx: mx,
    my: my,
    onAfterHistoryPush: onAfterHistoryPush,
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onPointerDown: onPointerDown,
    onPointerLeave: onPointerLeave,
    onPointerMove: onPointerMove,
    ref: ref,
    rel: rel,
    size: size,
    trailIcon: trailIcon,
    variant: variant,
    width: width,
    children: children
  });
});
Object.assign(ButtonLink, (_Object$assign = {}, _defineProperty(_Object$assign, allowedBadgeSymbols.ButtonLink, true), _defineProperty(_Object$assign, allowedTooltipSymbols.ButtonLink, true), _Object$assign));